import RequestError from "@/types/utils/RequestError";
import Apm from "@/utils/Apm";
import { AxiosResponse } from "axios";
import { createApiClient } from "@/utils/httpClient";

const api = createApiClient({
    baseURL:
        process.env.NEXT_PUBLIC_API_URL ||
        'https://assine3-be.estadao.com.br/',
    headers: {
        Authorization: process.env.API_TOKEN || '',
        "Content-Type": "application/json",
    },
})

export const verifyToken = async (token: string): Promise<void> => {
    return api.get(`/v1/auth/token?jwt=${encodeURIComponent(token)}`)
        .then(() => {
            // Success, no data needed
            document.cookie = "activate_signature=true; path=/; max-age=-1; domain=.estadao.com.br";
            document.cookie = `venda_suspeita=true;path=/;domain=.estadao.com.br;max-age=-1`;
            document.cookie = `id_pedido=;path=/;domain=.estadao.com.br;max-age=-1`;
        })
        .catch((err: RequestError) => {
            throw err;
        });
};

export const loginByEmail = async (jwt: string): Promise<any> => {
    return api.get(`v1/auth/auth-login?token=${jwt}`, {
        withCredentials: true,
    })
        .then((response: AxiosResponse) => response.data)
        .catch((err: RequestError) => {
            throw err;
        });
};

export const sendEmail = async (email: string, idPedido: number) => {
    try {
        const token = await api.post('v1/auth/generate-token', {
            "url_compra": window.location.href,
            "id_pedido": idPedido,
            "email": email
        })

        return await api.post('v1/auth/send-email', {
            "email": email,
            "id_pedido": idPedido,
            "token": token.data.token
        })
            .then((response: AxiosResponse) => response.data)
            .catch((err: RequestError) => {
                throw err;
            });
    } catch (error: any) {
        // safety net: cobre erros síncronos fora do request (ex.: shape da resposta),
        // já que o axios interceptor só cobre falhas de requisição
        Apm.captureError(error);
        throw error;
    }
}